<template>
  <div
    ref="main"
    v-loading="loading"
    class="task-detail"
  >
    <!-- <div class="task-edit-top">
      <div class="task-edit-title">
        创建任务111
      </div>
      <div class="task-step">
        <el-steps
          :active="stepActive"
          finish-status="finish"
        >
          <el-step title="第一步，添加任务信息" />
          <el-step title="第二步，添加任务目标" />
        </el-steps>
      </div>
    </div> -->
    <CardContent :title="`基础信息`">
      <el-form
        ref="taskForm"
        :rules="ruleTaskForm"
        :model="taskForm"
        label-width="100px"
      >
        <el-form-item
          label="任务标题："
          prop="task_title"
        >
          <el-input
            v-model="taskForm.task_title"
            class="input-b"
            placeholder="请输入活动名称"
            size="small"
          />
        </el-form-item>
        <el-form-item
          label="任务类型："
          prop="task_type"
        >
          <el-select
            v-model="taskForm.task_type"
            class="input-b"
            placeholder="请选择任务类型"
            :disabled="task_id !== '0'"
            size="small"
          >
            <el-option
              label="分享转发"
              :value="1"
            />
            <!-- <el-option label="客户招新" :value="2"></el-option>
              <el-option label="顾客下单" :value="3"></el-option>
              <el-option label="会员福利" :value="4"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item
          label="转发时间："
          prop="time"
        >
          <el-date-picker
            v-model="taskForm.time"
            :disabled="task_id !== '0'"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="mini"
          />
        </el-form-item>
        <el-form-item
          label="执行店铺："
          prop="store_id"
        >
          <el-radio-group v-model="taskForm.is_selected_all">
            <el-radio :label="true">
              全部门店
            </el-radio>
            <el-radio :label="false">
              指定门店
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="taskForm.is_selected_all === false"
          label=" "
        >
          <el-button
            type="primary"
            size="small"
            @click="storeVisible = true"
          >
            选择门店
          </el-button>
          <span
            v-if="selectStoreData.length > 0"
            class="select-tip"
          >
            已选择 {{ selectStoreData.length }} 家门店
          </span>
        </el-form-item>
      </el-form>
    </CardContent>
    <!-- 主任务 -->

    <!-- 子任务 -->
    <CardContent
      v-if="task_id !== '0'"
      title="任务目标"
    >
      <div
        class="select-tip"
        style="margin-bottom: 20px"
      >
        最多10个目标，排序不分先后
      </div>
      <!-- <div style="margin-bottom:20px;">
        <el-button
          size="small"
          @click="addSubTask"
        >
          +新增目标
        </el-button>
      </div> -->

      <el-tabs
        v-model="editableTabsValue"
        type="card"
        :before-leave="beforeLeave"
      >
        <el-tab-pane
          v-for="(subTaskForm, index) in subTaskData"
          :key="subTaskForm.subtask_id"
          :label="subTaskForm.subtask_title"
          :name="`${index}`"
        >
          <el-form
            ref="subTaskForm"
            :rules="ruleSubTaskForm"
            :model="subTaskForm"
            label-width="100px"
          >
            <el-form-item
              label="目标名称："
              prop="subtask_title"
            >
              <el-input
                v-model="subTaskForm.subtask_title"
                class="input-b"
                placeholder="请输入活动名称"
                size="small"
              />
            </el-form-item>

            <el-form-item
              label="转发时间："
              prop="time"
            >
              <el-date-picker
                v-model="subTaskForm.time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="subTaskForm.time_type !== 3"
                size="small"
              />
            </el-form-item>
            <el-form-item
              label="转发文字："
              prop="subtask_desc"
            >
              <el-input
                v-model="subTaskForm.subtask_desc"
                type="textarea"
                placeholder="请输入内容"
                format="yyyy-MM-dd HH:mm:ss"
                maxlength="80"
                show-word-limit
                class="input-b"
                :autosize="{ minRows: 3, maxRows: 6 }"
              />
            </el-form-item>
            <!-- <el-form-item label="执行角色" prop="task_type">
                <el-select class="input-b" v-model="subTaskForm.task_type" placeholder="选择角色">
                  <el-option label="店长" :value="1"></el-option>
                  <el-option label="区域经理" :value="2"></el-option>
                  <el-option label="行政主管" :value="3"></el-option>
                </el-select>
              </el-form-item> -->
            <el-form-item label="转发内容：">
              <el-radio-group
                v-model="subTaskForm.subtask_type"
                :disabled="subTaskForm.time_type !== 3"
                @change="(value) => radioChange(value, index)"
              >
                <el-radio
                  v-for="item in shareType"
                  :key="item.label"
                  :label="item.label"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              v-if="subTaskForm.subtask_type === 2"
              label="选择图片："
            >
              <MeterImgManager
                :disabled="subTaskForm.time_type !== 3"
                :meters="subTaskForm"
              />
            </el-form-item>
            <el-form-item
              v-if="subTaskForm.subtask_type === 1 || subTaskForm.subtask_type === 6"
              label="选择图片："
              prop="pics"
            >
              <MeterImgManager
                :disabled="subTaskForm.time_type !== 3"
                :meters="subTaskForm"
              />
            </el-form-item>

            <el-form-item
              v-if="subTaskForm.subtask_type === 4 || subTaskForm.subtask_type === 6"
              label="选择商品："
              prop="item_id"
            >
              <MeterGoodsManager
                :disabled="subTaskForm.time_type !== 3"
                :meters="subTaskForm"
              />
            </el-form-item>

            <el-form-item
              v-if="subTaskForm.subtask_type === 2"
              label="选择优惠券："
              prop="coupon"
            >
              <MeterCouponManager
                :disabled="subTaskForm.time_type !== 3"
                :meters="subTaskForm"
              />
            </el-form-item>

            <el-form-item
              v-if="subTaskForm.subtask_type === 7"
              label="选择视频："
              prop="videos"
            >
              <MeterVideoManager
                :disabled="subTaskForm.time_type !== 3"
                :meters="subTaskForm"
              />
            </el-form-item>

            <el-form-item
              v-if="subTaskForm.subtask_type === 8"
              prop="page"
              label="页面路径"
            >
              <el-input
                v-model="subTaskForm.page"
                :disabled="subTaskForm.time_type !== 3"
                class="input-b"
                placeholder="请输入页面路径"
              />
            </el-form-item>

            <div :style="{ marginLeft: '100px' }">
              <el-button
                v-if="subTaskForm.subtask_id && subTaskForm.subtask_status === 1"
                type="primary"
                size="small"
                @click="shelvesSubTask(index)"
              >
                关闭目标
              </el-button>
              <el-button
                v-if="!subTaskForm.subtask_id"
                type="primary"
                size="small"
                @click="deleteSubTask(index)"
              >
                删除任务目标
              </el-button>
              <el-button
                v-if="subTaskForm.subtask_status === 1"
                type="primary"
                size="small"
                :loading="subTaskForm.loading"
                @click="submitSubTask('subTaskForm', subTaskForm, index)"
              >
                保存任务目标
              </el-button>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          key="add"
          name="add"
        >
          <span
            slot="label"
            class="addLabel"
          > +新增目标 </span>
        </el-tab-pane>
      </el-tabs>
    </CardContent>
    <template>
      <div class="fotter-toolbar">
        <!-- <el-button
        type="primary"
        plain
        icon="el-icon-plus"
        @click="addSubTask"
      >
        继续添加目标
      </el-button> -->

        <template
          v-if="task_id === '0'"
          class="bottom-btn"
        >
          <el-button
            type="primary"
            :loading="taskLoading"
            @click="submitTask('taskForm')"
          >
            保存并添加任务目标
          </el-button>
        </template>
        <template v-if="task_id !== '0'">
          <el-button
            v-if="taskForm.task_status === 0 || taskForm.task_status === 1"
            type="danger"
            size="small"
            @click="shelvesTask"
          >
            <span v-if="taskForm.task_status === 1">关闭任务</span>
            <span v-else>发布任务</span>
          </el-button>
          <el-button
            type="primary"
            :loading="taskEditLoading"
            size="small"
            @click="updateSalesperosnTask"
          >
            保存任务
          </el-button>
        </template>
      </div>
    </template>

    <!-- 编辑门店 -->
    <SpStoreSelect
      v-model="storeVisible"
      :select-data="selectStoreData"
      @chooseStore="chooseStore"
    />
  </div>
</template>

<script>
import {
  createSalesperosnTask,
  updateTaskStore,
  updateSalesperosnTask,
  getTaskInfo,
  getSubTaskList,
  createSubTask,
  updateSubTask,
  shelvesTask,
  shelvesSubTask
} from '@/api/task/shoppingGuideTask'
import CardContent from '@/components/cardContent'
import MeterImgManager from '@/components/meterImgManager'
import MeterGoodsManager from '@/components/meterGoodsManager'
import MeterCouponManager from '@/components/meterCouponManager'
import MeterVideoManager from '@/components/meterVideoManager'

export default {
  components: {
    CardContent,
    MeterImgManager,
    MeterGoodsManager,
    MeterCouponManager,
    MeterVideoManager
  },
  data () {
    return {
      shareType: [
        { name: '图片', label: 1 },
        { name: '优惠券', label: 2 },
        { name: '商品', label: 4 },
        { name: '图片 + 商品', label: 6 },
        { name: '视频', label: 7 },
        { name: '页面', label: 8 }
      ],
      loading: false, //页面加载
      stepActive: 0, //步骤，0开始，1第一步完成，2第二步完成
      dialogImageUrl: '', // 预览图地址
      dialogVisible: false, //图片预览模态框展示与否
      task_id: '', //主任务的id值
      taskForm: {
        //主任务数据
        task_title: '', //任务标题
        task_type: '', //任务类型
        start_time: '', //开始时间
        end_time: '', //结束时间
        time: [], //时间范围
        store_id: '', //门店id值，多个逗号隔开
        is_selected_all: true //选择全部门店，默认全选
      },
      ruleTaskForm: {
        //主任务的表单验证规则
        task_title: [{ required: true, message: '请输入任务标题', trigger: 'blur' }],
        task_type: [{ required: true, message: '请选择任务类型', trigger: 'blur' }],
        time: [{ required: true, message: '请选择任务时间', trigger: 'blur' }]
      },

      ruleSubTaskForm: {
        //子任务的表单验证规则
        subtask_title: [{ required: true, message: '请输入目标名称', trigger: 'blur' }],
        time: [{ required: true, message: '请选择转发时间', trigger: 'blur' }],
        subtask_desc: [{ required: true, message: '请输入转发文字', trigger: 'blur' }],
        coupon: [{ required: true, message: '请选择优惠券', trigger: 'blur' }],
        item_id: [{ required: true, message: '请选择商品', trigger: 'blur' }],
        pics: [{ required: true, message: '请选择图片', trigger: 'blur' }],
        videos: [{ required: true, message: '请选择视频', trigger: 'blur' }],
        page: [{ required: true, message: '请输入页面路径', trigger: 'blur' }]
      },
      subTaskData: [], //子任务列表
      // 选择店铺
      storeVisible: false, //选择门店
      selectStoreData: [], //主任务门店列表
      storeIds: -1, //选择门店的id

      taskLoading: false, //创建主任务的加载
      currentIndex: -1, //编辑的子任务索引值
      taskEditLoading: false, //编辑主任务的加载

      editableTabsValue: '0'
    }
  },
  mounted () {
    let task_id = this.$route.params.task_id
    this.task_id = task_id

    if (task_id && task_id !== '0') {
      this.getTask(task_id)
    }
  },
  methods: {
    // 获取任务详情
    async getTask () {
      this.loading = true
      let taskId = this.task_id
      const data = await getTaskInfo(taskId, { taskId }).catch(() => {
        this.loading = false
      })
      if (data) {
        console.log('data--->', data)
        data.task.time = [data.task.start_time_str, data.task.end_time_str]
        this.taskForm = data.task
        this.selectStoreData = data.store_list
        this.storeIds = data.store_list.join(',')
        this.stepActive = 1

        this.getSubTaskList()
      }
    },
    // 获取子任务列表
    async getSubTaskList () {
      let taskId = this.task_id
      const data = await getSubTaskList(taskId, { taskId }).catch(() => {
        this.loading = false
      })
      if (data) {
        data.list.map((v) => {
          v.loading = false //添加子任务的默认按钮加载
          v.time = [v.start_time_str, v.end_time_str] //添加子任务的时间
          // 商品
          v.goodsVisible = false
          v.item_id = v.subtask_json.item_id.join(',')
          v.selectGoodsData = v.subtask_json.item_list
          // 优惠券
          v.couponVisible = false
          v.coupon = v.subtask_json.coupon.join(',')
          v.selectCouponData = v.subtask_json.coupon_list
          // 图片
          v.imageVisible = false
          v.pics = v.subtask_json.pic
          v.picsCurrent = -1 //操作图片的索引值
          // 视频
          v.videoVisible = false
          v.videos = v.subtask_json.video
          // 页面
          v.page = v.subtask_json.page
        })
        this.subTaskData = data.list //子任务的列表数据
        if (data.list.length > 0) {
          this.stepActive = 2 //子任务有数据，步骤显示2
        } else {
          this.stepActive = 1 //若无子任务，步骤显示1
        }
        this.loading = false //整个页面的加载
      }
    },
    // 保存主任务
    async submitTask (formName) {
      this.taskLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.createSalesperosnTask()
        } else {
          this.$message.error('请先填写必要信息')
          this.taskLoading = false
          return false
        }
      })
    },
    // 保存主任务接口
    async createSalesperosnTask () {
      const { task_title, task_type, is_selected_all } = this.taskForm
      let params = {
        task_title,
        task_type,
        start_time: this.taskForm.time[0],
        end_time: this.taskForm.time[1],
        is_selected_all
      }
      const data = await createSalesperosnTask(params).catch(() => {
        this.taskLoading = false
      })
      if (data) {
        data.is_selected_all = Boolean(data.is_selected_all)
        data.time = [data.start_time_str, data.end_time_str]
        this.task_id = data.task_id
        this.taskForm = data
        this.$router.push({ path: '/task/shoppingGuideTask/' + data.task_id })
        this.updateTaskStore('first')
      }
    },
    // 更新主任务接口
    async updateSalesperosnTask () {
      this.taskEditLoading = true
      let taskId = this.task_id
      const { task_title, task_type, is_selected_all } = this.taskForm
      let params = {
        task_title,
        task_type,
        start_time: this.taskForm.time[0],
        end_time: this.taskForm.time[1],
        is_selected_all: Boolean(is_selected_all)
      }
      const data = await updateSalesperosnTask(taskId, params).catch(() => {
        this.taskEditLoading = false
      })
      if (data) {
        this.updateTaskStore()
      }
    },
    // 保存主任务的门店接口
    async updateTaskStore (type) {
      let taskId = this.task_id
      let store_id = this.storeIds.length > 0 ? this.storeIds.split(',') : ''
      let is_selected_all = this.taskForm.is_selected_all
      const data = await updateTaskStore(taskId, { taskId, store_id, is_selected_all }).catch(
        () => {
          this.taskLoading = false
          this.taskEditLoading = false
        }
      )
      if (data) {
        this.$message({
          type: 'success',
          message: '任务保存成功'
        })
        if (type) {
          this.taskLoading = false
          this.stepActive = 1
          this.addSubTask()
        } else {
          // this.batchEditSubTask()
          this.taskEditLoading = false
          this.$router.push({ path: '/task/shoppingGuideTask' })
        }
      }
    },
    // 关闭任务 下架主任务
    shelvesTask () {
      let task_status = this.taskForm.task_status
      let message = task_status === 1 ? '终止' : '开启'
      this.$confirm('此操作将' + message + '该任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: task_status === 1 ? 'warning' : ''
      })
        .then(async () => {
          let taskId = this.task_id
          const data = await shelvesTask(taskId, { taskId, task_status: task_status === 0 ? 1 : 0 })
          if (data) {
            this.getTask()
            this.$message({
              type: 'success',
              message: '操作成功'
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    // 删除子任务
    deleteSubTask (index) {
      this.subTaskData.splice(index, 1)
      const i = index - 1
      this.editableTabsValue = i + ''
    },
    // 子任务选择变更转发内容
    radioChange (value, index) {
      if (value) {
        this.subTaskData[index].pics = []
        this.subTaskData[index].videos = []
        this.subTaskData[index].selectGoodsData = []
        this.subTaskData[index].selectCouponData = []
        this.subTaskData[index].subtask_json = {
          pic: '',
          item_id: '',
          coupon: '',
          page: ''
        }
      }
    },
    // 添加子任务
    addSubTask () {
      let params = {
        subtask_title: '子任务名称', //目标名称
        time: [], //转发时间
        start_time: '', //开始时间
        end_time: '', //结束时间
        subtask_type: 1, //子任务类型 [1 图片] [2 优惠券] [3直播] [4商品][5活动][6图片+商品]
        subtask_desc: '', //任务描述
        pics: [], //图片列表
        videos: [], //视频列表
        selectGoodsData: [], //选择商品列表
        selectCouponData: [], //选择优惠券列表
        subtask_json: {
          //提交选择素材的字段
          pic: '', //选择的图片地址，多个逗号隔开
          item_id: '', //选择的商品id，多个逗号隔开
          coupon: '' //选择的优惠券id，多个逗号隔开
          // download: 1 //图片下载样式，1海报 2原图
        },
        goodsVisible: false, //选择商品组件展示与否
        couponVisible: false, //选择优惠券组件展示与否
        imageVisible: false, //选择图片组件展示与否
        picsCurrent: -1, //选中的当前图片
        item_id: '', //选择的商品id，多个逗号隔开(便于表单验证)
        coupon: '', //选择的优惠券id，多个逗号隔开(便于表单验证)
        time_type: 3, //子任务时间状态 1：已结束，2正在进行，3：未开始
        subtask_status: 1, //子任务上下架状态[0 关闭] [1 开启]
        loading: false //子任务的保存按钮的加载
      }
      if (this.subTaskData.length >= 10) {
        return this.$message.error('最多10个目标')
      }
      this.subTaskData.push(params)
      this.editableTabsValue = this.subTaskData.length - 1 + ''
    },
    beforeLeave (currentName, oldName) {
      var self = this
      if (currentName === 'add') {
        this.addSubTask()
        return false
      } else {
        console.log('currentName', currentName)
      }
    },
    // 保存子任务
    submitSubTask (formName, subTaskForm, index) {
      console.log('subTaskForm', subTaskForm)
      this.subTaskData[index].loading = true
      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          if (subTaskForm.subtask_id) {
            this.editSubTask(subTaskForm, index)
          } else {
            this.createSubTask(index)
          }
        } else {
          this.$message.error('请先填写必要信息')
          this.subTaskData[index].loading = false
          return false
        }
      })
    },

    // 编辑/新建子任务的参数
    getSubTaskParams (obj) {
      return {
        task_id: this.task_id,
        task_type: this.taskForm.task_type,
        subtask_id: obj.subtask_id || '',
        subtask_title: obj.subtask_title,
        subtask_json: {
          pic: obj.pics.join(','),
          video: obj.videos.join(','),
          item_id: obj.item_id,
          coupon: obj.coupon,
          page: obj.page
          // download: obj.subtask_json.download
        },
        subtask_type: obj.subtask_type,
        start_time: obj.time[0],
        end_time: obj.time[1],
        subtask_desc: obj.subtask_desc
      }
    },
    // 创建新的子任务
    async createSubTask (index) {
      let obj = this.subTaskData[index]
      let parmas = this.getSubTaskParams(obj)
      const data = await createSubTask(parmas).catch(() => {
        this.subTaskData[index].loading = false
      })
      if (data) {
        this.subTaskData[index].subtask_id = data.subtask_id
        this.$message({
          type: 'success',
          message: '目标保存成功'
        })
        this.stepActive = 2
        this.getSubTaskList()
        this.subTaskData[index].loading = false
      }
    },
    // 编辑子任务
    async editSubTask (subTaskForm, index) {
      let parmas = this.getSubTaskParams(subTaskForm)
      const data = await updateSubTask(subTaskForm.subtask_id, parmas).catch(() => {
        this.subTaskData[index].loading = false
      })
      if (data) {
        this.$message({
          type: 'success',
          message: '目标更新成功'
        })
        this.subTaskData[index].loading = false
      }
    },
    // 批量操作子任务
    batchEditSubTask () {
      console.log(this.subTaskData, 'subTaskDatasubTaskDatasubTaskData')
      let params = []
      this.subTaskData.forEach((v) => {
        params.push(this.getSubTaskParams(v))
      })
      console.log(params, 'paramsparamsparams')
      params.forEach(async (v) => {
        if (v.subtask_id) {
          await updateSubTask(v.subtask_id, v)
        } else {
          await createSubTask(v)
        }
      })
    },
    // 下架子任务
    async shelvesSubTask (index) {
      this.$confirm('此操作将终止该目标, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let obj = this.subTaskData[index]
          const data = await shelvesSubTask(obj.subtask_id, {
            subtask_id: obj.subtask_id,
            subtask_status: 0
          })
          if (data) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            obj.subtask_status = data.subtask_status
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    // 选择门店
    chooseStore (selectdata, storeids) {
      if (selectdata.length > 0) {
        this.selectStoreData = selectdata
        this.storeIds = storeids
        this.taskForm.store_id = storeids
        this.taskForm.is_selected_all = false
      } else {
        this.selectStoreData = []
        this.taskForm.is_selected_all = true
      }
      this.storeVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
// .task-detail{
//   padding-bottom:30px;
// }
.addLabel {
  font-size: 14px;
  color: #1890ff;
}
.subtask-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box-card {
  margin-bottom: 20px;
}
.select-tip {
  font-size: 12px;
  color: #999999;
}
.sub-box-card {
  .subtask-title {
    margin: -9px 0;
  }
}
.task-edit-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  .task-edit-title {
    font-size: 28px;
    color: #606266;
  }
  .task-step {
    width: 380px;
  }
}
.bottom-btn {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.pics-box {
  overflow: hidden;
  .goodspic-wrap {
    float: left;
    margin-right: 5px;
    overflow: hidden;
    .goodspic {
      position: relative;
      float: left;
      width: 146px;
      height: 146px;
      margin: 0 5px 10px;
      border: 1px solid #ddd;
      border-radius: 8px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      .goodspic-mask {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        line-height: 146px;
        cursor: pointer;

        .icon1,
        .icon2 {
          color: #fff;
          display: inline-block;
          font-size: 20px;
        }

        .icon2 {
          margin-left: 14px;
        }

        &.on {
          display: block;
        }
      }
    }
  }

  .upload-box {
    float: left;
    width: 146px;
    height: 146px;
    .avatar-uploader-icon {
      width: 100%;
      height: 100%;
      line-height: 146px;
    }
    .avatar-uploader-icon {
      font-size: 38px;
    }
  }
}
.upload-box {
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;

  .el-icon-plus {
    font-size: 24px;
  }

  &:hover {
    border-color: #409eff;
  }
}

.select-tips {
  margin-left: 20px;
}
::v-deep .el-tabs--card {
  > .el-tabs__header {
    background: #fafafa;
    .el-tabs__nav {
      border-radius: 0;
      height: 48px;
      border: none;
    }
    .el-tabs__item {
      padding: 0 10px;
      text-align: center;
      color: #666666;
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 48px;
      line-height: 48px;
      border-left: none;
      position: relative;
      &::after {
        content: '';
        width: 1px;
        height: 32px;
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -16px;
        background: #f5f5f5;
      }
      &.is-active {
        background: #fff;
        color: #111111;
        position: relative;
        border: 1px solid #e4e7ed;
        border-bottom: transparent;
        &::after {
          content: '';
          background: transparent;
        }
        //border-color: #F5F5F5;
      }
    }
  }
}
.footer-opera {
  background: #fff;
  position: fixed;
  left: 250px;
  bottom: 0;
  right: 0;
  box-shadow: 0px 0px 4px 0px rgba(0, 21, 41, 0.12);
  height: 56px;
  line-height: 56px;
  text-align: center;
}
</style>
